import { ALL_GROUP_IDS } from './benchmarkIndexGroups';

const KEY = 'banyan_benchmark_index_groups';

// Selected group ids for prefilling a FRESH report dialog open. Default (no
// saved value) is "all selected" so first-ever behavior shows every benchmark.
// An explicitly-saved empty array is preserved (the PM chose to show none of
// the curated benchmarks).
export function loadBenchmarkGroups() {
  try {
    const raw = window.localStorage.getItem(KEY);
    if (raw == null) return [...ALL_GROUP_IDS];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [...ALL_GROUP_IDS];
  } catch (e) {
    return [...ALL_GROUP_IDS];
  }
}

export function saveBenchmarkGroups(groupIds) {
  try {
    window.localStorage.setItem(KEY, JSON.stringify(Array.isArray(groupIds) ? groupIds : []));
  } catch (e) {
    /* localStorage unavailable - prefill silently degrades to default */
  }
}
